import { commentCommandStateStore as e } from "./CommentCommandState.js";
import { createStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useStore as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { useShallow as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { ComponentItem as i, EntityItem as a, assert as o } from "@magnopus-opensource/magnopus-web-common";
import { HierarchySortOption as s } from "@magnopus/shared-ui-types";
//#region src/UIState.ts
var c = (e, t) => {
	let n = (e, r, i, a, o, s) => {
		if (t(r, s)) return e.push(r), e;
		if (Array.isArray(r.children) && r.children.length > 0) {
			let t = r.children.reduce((e, t, r, i) => n(e, t, r, i, o + 1, t), []);
			t.length && e.push({
				...r,
				children: o > 0 ? r.children : t
			});
		}
		return e;
	};
	return e.reduce((e, t, r, i) => n(e, t, r, i, 0), []);
}, l = (e) => {
	let t = [];
	for (let n of e) t.push(n.id), n.children && t.push(...l(n.children));
	return t;
}, u = (e, t = "-") => {
	let n = e.split(t);
	return n.length === 2 ? new i(BigInt(n[0]), parseInt(n[1])) : new a(BigInt(n[0]));
}, d = (e, t) => {
	let n = [], r, i;
	for (n.push(t); n.length > 0;) {
		if (r = n.pop(), o(r), r.id === e) return r;
		if (r.children && r.children.length) for (i = 0; i < r.children.length; i += 1) n.push(r.children[i]);
	}
	return null;
}, f = (e, t) => {
	let n = t.length > 0 ? t[t.length - 1] : void 0;
	if (n) return e.get(n);
}, p = () => ({
	dismissedProperties: !1,
	currentCleanupHandlers: /* @__PURE__ */ new Map(),
	activeLeftPanels: { panels: [] },
	activeRightPanels: { panels: [] },
	activeBottomPanels: { panels: [] },
	panelResizeDimensions: JSON.parse(localStorage.getItem("oko.preferences.panel-dimensions") || "{}"),
	hierarchySort: s.Default,
	lastRequestedLeft: void 0,
	lastRequestedRight: void 0,
	lastRequestedBottom: void 0,
	expandedNodeIds: ["space"],
	showHelpPanel: !1,
	showNodeyPanel: !1,
	openNodeyFromInline: !1,
	showSettingPanel: !1,
	showGraphicsSettings: !1,
	showSpaceSharePanel: !1,
	showSnapshotsPanel: !1,
	showImageModal: !1,
	imageModalImages: [],
	showImageModalThumbnails: !1,
	imageModalDarkMode: !1,
	hierarchy: {
		id: "root",
		type: "space"
	},
	hierarchySelectedSubset: void 0,
	activeComment: void 0,
	commentCommand: "none",
	annotationCommand: "none",
	assetViewType: "grid",
	activeAsset: void 0,
	selectedMaterial: void 0,
	additionalCenterOptionsVisible: !1,
	initialCarouselImageIndex: 0
}), m = t((t, n) => ({
	...p(),
	closeAllLeft: () => {
		t((e) => ({ activeLeftPanels: {
			...e.activeLeftPanels,
			panels: []
		} }));
	},
	closeAllRight: () => {
		t((e) => ({ activeRightPanels: {
			...e.activeRightPanels,
			panels: []
		} }));
	},
	closeAllBottom: () => {
		t((e) => ({ activeBottomPanels: {
			...e.activeBottomPanels,
			panels: []
		} }));
	},
	closeAll: () => {
		t((e) => ({
			activeLeftPanels: {
				...e.activeLeftPanels,
				panels: []
			},
			activeRightPanels: {
				...e.activeRightPanels,
				panels: []
			},
			activeBottomPanels: {
				...e.activeBottomPanels,
				panels: []
			}
		}));
	},
	toggleOrReplaceLeft: (e) => t((n) => {
		let r = () => {
			let t = n.activeLeftPanels.panels;
			return t.length > 0 && t[t.length - 1] === e ? { activeLeftPanels: {
				...n.activeLeftPanels,
				panels: []
			} } : { activeLeftPanels: {
				...n.activeLeftPanels,
				panels: [e]
			} };
		}, i = f(n.currentCleanupHandlers, n.activeLeftPanels.panels);
		return i ? (i(() => t(r())), n) : r();
	}),
	toggleOrReplaceRight: (e) => t((n) => {
		let r = () => {
			let t = n.activeRightPanels.panels;
			return t.length > 0 && t[t.length - 1] === e ? {
				activeRightPanels: {
					...n.activeRightPanels,
					panels: []
				},
				dismissedProperties: n.dismissedProperties ? !0 : e === "properties"
			} : { activeRightPanels: {
				...n.activeRightPanels,
				panels: [e]
			} };
		}, i = f(n.currentCleanupHandlers, n.activeRightPanels.panels);
		return i ? (i(() => t(r())), n) : r();
	}),
	toggleOrReplaceBottom: (e) => t((n) => {
		let r = () => {
			let t = n.activeBottomPanels.panels;
			return t.length > 0 && t[t.length - 1] === e ? { activeBottomPanels: {
				...n.activeBottomPanels,
				panels: []
			} } : { activeBottomPanels: {
				...n.activeBottomPanels,
				panels: [e]
			} };
		}, i = f(n.currentCleanupHandlers, n.activeBottomPanels.panels);
		return i ? (i(() => t(r())), n) : r();
	}),
	setLastRequestedLeft: (e) => t((t) => ({ lastRequestedLeft: e })),
	setLastRequestedRight: (e) => t((t) => ({ lastRequestedRight: e })),
	setLastRequestedBottom: (e) => t((t) => ({ lastRequestedBottom: e })),
	showProperties: () => t((e) => (!(e.activeRightPanels.panels.length > 0 && e.activeRightPanels.panels[e.activeRightPanels.panels.length - 1] === "properties") && !e.dismissedProperties && e.toggleOrReplaceRight("properties"), {})),
	setActiveAsset: (e) => t((t) => (e && !(t.activeRightPanels.panels.length > 0 && t.activeRightPanels.panels[t.activeRightPanels.panels.length - 1] === "asset-details") && (t.setLastRequestedRight("asset-details"), t.activeRightPanels.panels.length > 0 && t.toggleOrReplaceRight("asset-details")), { activeAsset: e })),
	setSelectedMaterial: (e) => t((r) => {
		e && !(r.activeRightPanels.panels.length > 0 && r.activeRightPanels.panels[r.activeRightPanels.panels.length - 1] === "material-details") && (r.setLastRequestedRight("material-details"), r.activeRightPanels.panels.length > 0 && r.toggleOrReplaceRight("material-details"));
		let i = f(r.currentCleanupHandlers, r.activeRightPanels.panels);
		return i ? (i(() => {
			t({ selectedMaterial: e }), n().toggleOrReplaceRight("material-details");
		}), r) : { selectedMaterial: e };
	}),
	editMaterial: (e, n) => t((t) => (e ? (t.setLastRequestedRight("material-form"), t.activeRightPanels.panels.includes("material-form") || t.toggleOrReplaceRight("material-form")) : n ? (t.setLastRequestedRight("material-details"), t.activeRightPanels.panels.includes("material-details") || t.toggleOrReplaceRight("material-details")) : (t.setLastRequestedRight("properties"), t.activeRightPanels.panels.includes("properties") || t.toggleOrReplaceRight("properties")), { selectedMaterial: n })),
	createMaterial: (e) => {
		t((t) => (t.setLastRequestedRight("material-form"), t.activeRightPanels.panels.includes("material-form") || t.toggleOrReplaceRight("material-form"), { newMaterialShaderType: e }));
	},
	clearNewMaterialRequest: () => {
		t((e) => ({ newMaterialShaderType: void 0 }));
	},
	setShowNodeyPanel(e) {
		t(() => ({ showNodeyPanel: e }));
	},
	setOpenNodeyFromInline(e) {
		t(() => ({ openNodeyFromInline: e }));
	},
	setAdditionalCenterOptionsVisible: (e) => t((t) => ({ additionalCenterOptionsVisible: e })),
	setShowHelpPanel: (e) => t((t) => ({ showHelpPanel: e })),
	setShowSettingPanel: (e) => t((t) => ({ showSettingPanel: e })),
	setShowGraphicsSettings: (e) => t((t) => ({ showGraphicsSettings: e })),
	setShowSpaceSharePanel: (e) => t((t) => ({ showSpaceSharePanel: e })),
	setShowSnapshotsPanel: (e) => t((t) => ({ showSnapshotsPanel: e })),
	setAssetViewType: (e) => t((t) => ({ assetViewType: e })),
	setExpandedNodeIds: (e) => t((t) => ({ expandedNodeIds: e })),
	setShowImageModal: (e, n, r, i, a) => t((t) => ({
		showImageModal: e,
		imageModalImages: n,
		showImageModalThumbnails: r,
		imageModalDarkMode: i,
		initialCarouselImageIndex: a || 0
	})),
	setActiveComment: (e) => t((t) => (e.length > 0 && (t.activeRightPanels.panels.length === 0 || t.activeRightPanels.panels[t.activeRightPanels.panels.length - 1] !== "comment-detail") ? (t.setLastRequestedRight("comment-detail"), t.toggleOrReplaceRight("comment-detail")) : e.length === 0 && t.activeRightPanels.panels[t.activeRightPanels.panels.length - 1] === "comment-detail" && (t.toggleOrReplaceRight("comment-detail"), t.setLastRequestedRight(void 0)), { activeComment: e })),
	setCommentCommand: (n) => t((t) => ((n === "create" || n === "edit") && !(t.activeRightPanels.panels.length > 0 && t.activeRightPanels.panels[t.activeRightPanels.panels.length - 1] === "comment-detail") && t.toggleOrReplaceRight("comment-detail"), n === "none" && e.getState().clear(), { commentCommand: n })),
	setAnnotationCommand: (e) => t((t) => ({ annotationCommand: e })),
	loadHierarchy: (e) => {
		t(() => ({ hierarchy: e }));
	},
	setCurrentCleanupHandler: (e, r) => {
		let i = n().currentCleanupHandlers;
		r ? i.set(e, r) : i.delete(e), t({ currentCleanupHandlers: new Map(i) });
	},
	reset: () => t(() => ({ ...p() })),
	setPanelDimension: (e, n) => {
		t((t) => {
			let r = t.panelResizeDimensions;
			return r[e] !== n && Number.isInteger(n) ? (r[e] = n, localStorage.setItem("oko.preferences.panel-dimensions", JSON.stringify(r)), { panelResizeDimensions: { ...r } }) : {};
		});
	},
	resetPanelDimensions: () => {
		localStorage.removeItem("oko.preferences.panel-dimensions"), t({ panelResizeDimensions: {} });
	},
	setHierarchySort: (e) => t(() => ({ hierarchySort: e }))
})), h = (e) => n(m, r(e));
//#endregion
export { m as UIStateStore, c as filterNodeTree, d as getNodeById, u as idToItem, l as treeNodeToFlatIdArray, h as useUIStateStore };
